import script from "./POSView.vue?vue&type=script&setup=true&lang=js"
export * from "./POSView.vue?vue&type=script&setup=true&lang=js"

import "./POSView.vue?vue&type=style&index=0&id=7c66e357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c66e357"]])

export default __exports__